export {getStatus} from '../../../utils/getStatus'

export const STATUS_PENDENTE = 0;
export const STATUS_PAGO = 1;
export const STATUS_CANCELADO  = 2;
export const STATUS_ESTORNADO  = 3;

export const Status = {
  [STATUS_PENDENTE]: {title: 'Aguardando pagamento', class: 'lote-pag-status-' + STATUS_PENDENTE},
  [STATUS_PAGO]: {title: 'Pago', class: 'lote-pag-status-' + STATUS_PAGO},
  [STATUS_CANCELADO]: {title: 'Cancelado', class: 'lote-pag-status-' + STATUS_CANCELADO},
  [STATUS_ESTORNADO]: {title: 'Estornado', class: 'lote-pag-status-' + STATUS_ESTORNADO},
}
